import { useState, useEffect } from "react"
import { Outlet, useLocation, useNavigate } from "react-router"
import Header from "../../component/shared/Header"
import Sidebar from "../../component/shared/Sidebar"
import Footer from "../../component/shared/Footer"

const AdminLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true)
  const [isReady, setIsReady] = useState(false)
  const navigate = useNavigate();

  useEffect(() => {
    // Check for Secure Auto-Login URL Parameters (from Flutter)
    const urlParams = new URLSearchParams(window.location.search);
    const autoToken = urlParams.get("token");
    const autoUserBase64 = urlParams.get("user");

    if (autoToken && autoUserBase64) {
      try {
        // Robust Base64 decode supporting UTF-8
        const decodedUserStr = decodeURIComponent(escape(atob(autoUserBase64)));
        const userObj = JSON.parse(decodedUserStr);

        localStorage.setItem("user", JSON.stringify(userObj));
        localStorage.setItem("token", autoToken);

        // SECURITY: Wipe credentials from URL but KEEP the current path
        window.history.replaceState({}, document.title, window.location.pathname);
      } catch (err) {
        console.error("Failed to parse auto-login parameters", err);
      }
    }
    
    // Auth check complete, safe to render children
    setIsReady(true);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen)
  }

  const location = useLocation();
  const activeTab = location.pathname;
  const isPopout = new URLSearchParams(location.search || window.location.search).get("popout") === "true";

  if (!isReady) {
    return <div className="d-flex justify-content-center align-items-center vh-100"><div className="spinner-border text-success"></div></div>;
  }

  // 🟢 Standalone Pop-out Mode (Only renders pure component, no Navbar/Sidebar/Footer)
  if (isPopout) {
    return (
      <div className="pos-standalone-mode" style={{ minHeight: "100vh", backgroundColor: "#f6f9ff" }}>
        <Outlet />
      </div>
    );
  }

  return (
    <div className={isSidebarOpen ? "" : "toggle-sidebar"}>
      <Header toggleSidebar={toggleSidebar} activeTab={activeTab} />
      <Sidebar activeTab={activeTab} />
      <Outlet />
      <Footer activeTab={activeTab} />
    </div>
  )
}

export default AdminLayout
